import 'react';
import { Col, Row } from 'antd';

import OrderLineItemsTable from '../../../components/OrderLineItemsTable/index.tsx';
import Header from '../../../components/Header/index.tsx';
import { Link } from 'react-router-dom';

const OrderLineItems = () => {
	return (
		<main data-testid="page-fastlane-order-line-items" data-ready="true">
			<Header
				title="Order Line Items"
				breadcrumbItems={[
					{
						title: <Link to="/">Home</Link>,
					},
					{
						title: 'Order Line Items',
					},
				]}
			/>
			<Row>
				<Col span={24}>
					<OrderLineItemsTable />
				</Col>
			</Row>
		</main>
	);
};

export default OrderLineItems;
